import router from '../../../router';
import {ApiFilter, AppResourceSearch} from "@milestoneslabs/milestones-js-engine";
import isEmpty from 'lodash/isEmpty';

export default {

    getOrganizationUuid: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return getters.getCurrentWorkspace.organizationUuid;
    },

    getOrganization: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return getters.getCurrentWorkspace.organization;
    },


    getProjectOrganizationMember: (state) => {
        return state.currentProjectOrganizationMember;
    },

    getCurrentWorkspace(state, getters) {
        return state.currentWorkspace;
    },

    getWorkspaceUuid: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }

        return getters.getCurrentWorkspace.uuid;
    },

    getWorkspaceOrganizationMemberUuid: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return Object.values(
            getters.getCurrentWorkspace.get('members')._appResources)
            .find(
                (member) => member.userUuid === getters.authUser.uuid,
            )._uuid;
    },

    getWorkspaceOrganizationMember: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }

        return Object
            .values(getters.getCurrentWorkspace.get('members')._appResources)
            .find((member) => member.userUuid === getters.authUser.uuid);
    },

    getOrganizationMemberUuid: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return Object.values(
            getters.getCurrentWorkspace.get('members')._appResources)
            .find(
                (member) => member.userUuid === getters.authUser.uuid,
            ).organizationMemberUuid;
    },

    getCurrentWorkspaceMembers: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return getters.getCurrentWorkspace.get('members');
    },

    getCurrentProjectStages: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }

        return state.currentProjectStages;
    },

    getCurrentWorkspaceSettings: (state, getters) => {
        if (isEmpty(getters.getCurrentWorkspace)) {
            return null;
        }
        return getters.getCurrentWorkspace.get('settings');
    },

    getCurrentWorkspaceChannels: (state) => {
        if (state.currentWorkspaceChannels === null) {
            return null;
        }
        return state.currentWorkspaceChannels;
    },

    areChannelsLoaded: (state) => {
        return state.areChannelsLoaded;
    },

    // TODO: We need to remove 'workspace' from store

    getPlanStage: (state) => {
        return state.workspace.customStages.plan;
    },
    getSearchStage: (state) => {
        return state.workspace.customStages.search;
    },
    getInspectStage: (state) => {
        return state.workspace.customStages.inspect;
    },
    getCloseStage: (state) => {
        return state.workspace.customStages.close;
    },

    // Used only for property search integration on `buy` landing page
    getCurrentProjectMlsId: (state, getters) => {
        //to to: change the local storage usage for this default
        let defaultMlsId = state.defaultMlsAbbreviation || null;
        return (( getters.getCurrentWorkspace || {}).mlsMarket || {}).mlsMarketId || defaultMlsId;
    },

    getDefaultMapCoordinates: (state) => {
        return state.defaultSwNeMapLocationCoordinates;
    },

    getBuyFilter: (state) => {
        return state.buyFilter;
    },
};
